module.exports = __webpack_public_path__ + "static/media/IphoneHebrew.85218299.png";